module.exports = __webpack_public_path__ + "37504837ea741a70f37225ee39ba23ee.svg";